var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.06 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.85 7.26l-7.06-7a.7.7 0 00-1.2.5v3.47h-6.36a.71.71 0 000 1.42h7.06a.71.71 0 00.71-.71V2.41l5.4 5.4-5.4 6.48V12a.71.71 0 00-.71-.71H8.47V7.76a.7.7 0 00-1.2-.5L.21 14.32a.72.72 0 000 1l7.06 8.47a.72.72 0 00.54.25A.64.64 0 008 24a.71.71 0 00.47-.67v-3.57h6.35a.7.7 0 00.71-.7.71.71 0 00-.71-.71H7.76a.7.7 0 00-.7.71v2.28l-5.4-6.47 5.4-5.4V12a.7.7 0 00.7.71h14.83v3.53a.7.7 0 00.47.66.59.59 0 00.23 0 .73.73 0 00.55-.25l7.05-8.47a.71.71 0 000-1",
    fill: "#12100b",
    fillRule: "evenodd"
  })));
}
SvgExchange.displayName = 'Exchange';
export default SvgExchange;